// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"8a076426","946":"26a43f1c"}[chunkId] + ".chunk.js";
};